import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import donto from '../assets/home/about-banner1.png';
import dontoAnimated from '../assets/home/cleaner.png';
import styleAcerca from './AcercaDe.module.css';

const AcercaDe = () => {

    useEffect(() => {
        AOS.init({
            duration: 1000,
        });
        AOS.refresh();
    }, []);

    return (
        <section className={styleAcerca["about-wrapper"]}>
            <Container>
                <Row>
                    <Col md={12} lg={6}>
                        <div className={styleAcerca["about-left"]}>
                            <img src={donto} alt="donto" className={`img-fluid ${styleAcerca.donto}`} />
                            <img src={dontoAnimated} alt="donto" className={`img-fluid animated ${styleAcerca.dontoAnim}`} />
                        </div>
                    </Col>
                    <Col md={12} lg={6}>
                        <div className={`${styleAcerca["about-right"]} mt-5 mt-lg-0`}>
                            <div className={`${styleAcerca["about-content"]} text-start`} data-aos="zoom-in">
                                <h1>Bienvenidos a Dentisan</h1>
                                <p>En Dentisan Clínica Dental nos enorgullece ofrecer una experiencia completamente renovada en el cuidado bucal. Sabemos que, tradicionalmente, una visita al dentista puede generar ansiedad o incomodidad. Por eso, hemos transformado esa percepción: aquí, tu cita dental deja de ser una experiencia temida para convertirse en un momento de bienestar y tranquilidad. </p>
                                <p>Nuestro enfoque combina tecnología de vanguardia, atención personalizada y un ambiente acogedor, pensado para que te sientas cómodo desde el primer momento. Cada detalle ha sido diseñado para cuidar de tu salud bucal con profesionalismo, cercanía y el máximo confort.</p>
                                <p>En Dentisan, no solo cuidamos tu sonrisa, también nos aseguramos de que disfrutes el proceso.</p>
                                <a href='../Nosotros'>Sobre Nosotros</a>
                            </div>
                            <div className={styleAcerca["fun-fact-sec"]} data-aos="fade-right">
                                <div className={styleAcerca["single-fun"]}>
                                    <span>500</span>
                                    <span>+</span>
                                    <p>Pacientes Satisfechos</p>
                                </div>
                                <div className={`${styleAcerca["single-fun"]} ${styleAcerca["sp-fun"]}`} data-aos="fade-right">
                                    <span>10</span>
                                    <span>+</span>
                                    <p>Doctores Calificados</p>
                                </div>
                                <div className={styleAcerca["single-fun"]} data-aos="fade-left">
                                    <span>15</span>
                                    <span>+</span>
                                    <p>Años de experiencia</p>
                                </div>
                                <div className={`${styleAcerca["single-fun"]} ${styleAcerca["sp-fun"]}`} data-aos="fade-left">
                                    <span>50</span>
                                    <span>+</span>
                                    <p>Premios Dentales</p>
                                </div>
                                <span className={styleAcerca.line}></span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AcercaDe;

